import { defineAsyncComponent } from 'vue'
export default {
  administration: defineAsyncComponent(() => import("/app/packages/main/layouts/administration.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/packages/main/layouts/default.vue").then(m => m.default || m)),
  dialog: defineAsyncComponent(() => import("/app/packages/main/layouts/dialog.vue").then(m => m.default || m)),
  manual: defineAsyncComponent(() => import("/app/packages/main/layouts/manual.vue").then(m => m.default || m)),
  share: defineAsyncComponent(() => import("/app/packages/main/layouts/share.vue").then(m => m.default || m))
}